import { salesSideBarConfig } from "app/components/sidebar3/dynamic-config/configs/sidebar31/salesSideBarConfig";
import { sideBar31Config } from "app/components/sidebar3/dynamic-config/configs/sidebar31/sideBar31Config";
import type { SidebarConfig } from "app/components/sidebar3/dynamic-config/types";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const getSidebarConfig = (): SidebarConfig => {
    return proNavigator.isSalesSolution() ? salesSideBarConfig : sideBar31Config;
};
